// The citation and attribution helpers of the Gen AI card, kept out of the
// widget file so they can be tested (and read) without importing it.

/** Format a unix-millis attribution timestamp for the "Edited by / Signed off by" badges. */
export function formatAttributionDate(unixMillis: number): string {
  return new Date(unixMillis).toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
  })
}

const TABLE_CITATION_RE = /\[Table:\s*([^\]]+)\]/g

/** Distinct [Table: ...] citation labels present in a report's raw text, in first-seen order. */
export function extractTableChips(text: string): string[] {
  const seen = new Set<string>()
  const labels: string[] = []
  for (const match of text.matchAll(TABLE_CITATION_RE)) {
    const label = match[1].trim()
    if (label && !seen.has(label)) {
      seen.add(label)
      labels.push(label)
    }
  }
  return labels
}

/** Strip a display label for the chip strip (drop the " Analysis" suffix, matching citation-click resolution). */
export function chipDisplayLabel(label: string): string {
  return label.endsWith(' Analysis') ? label.slice(0, -9) : label
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/** Remove every occurrence of a specific [Table: label] citation token from text. Delete-only — the
 * table binding itself cannot be edited/rebound from the text-edit surface (#963). */
export function removeTableCitation(text: string, label: string): string {
  const pattern = new RegExp(`\\s*\\[Table:\\s*${escapeRegExp(label)}\\]`, 'g')
  return text.replace(pattern, '')
}
